import { useEffect, useRef, useState } from 'react';
import iconCalendar from '../../images/icon-calendar.svg';
import CustomDatePicker from '../ui/DatePicker';

export default function NonconformList({ inOut, setInOut, nonconform, setDetail, setDetailData, auth, date, setDate }: any) {
  const [statusTab, setStatusTab] = useState('전체');
  const [datePopup, setDatePopup] = useState(false);
  const [dateView, setDateView] = useState('');
  const prodRef = useRef<any>();
  const datePopupOpen = () => { setDatePopup(!datePopup); };
  const detailHandler = (nonconform: any) => {
    setDetailData(nonconform);
    setDetail(true);
  };
  useEffect(() => {
    let year = date.getFullYear();
    let month: number = date.getMonth() + 1;
    let day = date.getDate();
    setDateView(`${year}. ${month >= 10 ? month : '0' + month}. ${day >= 10 ? day : '0' + day}`);
  }, [date]);

  return (
    <>
      <div className='h-125 md:h-[312px] flex flex-col items-center pt-12 md:pt-[30px]'>
        {(auth === 'KOX' || auth === 'SRV') &&
          <div onClick={datePopupOpen} ref={prodRef} className='hover:cursor-pointer w-[265px] sm:w-[318px] md:w-[750px] h-43 md:h-[107px] bg-[#2F2F35] flex justify-between items-center rounded-[5px] md:roudned-[12px]'>
            <p className='text-14 ml-15 sm:text-15 sm:ml-20 md:text-37 md:ml-[50px] font-preBold '>날짜</p>
            <p className='w-170 text-13 sm:text-15 md:text-37  font-preLight sm:w-[210px] md:w-[525px]'>{dateView}</p>
            <img className='w-16 mr-16 md:w-[40px] md:mr-[40px]' src={iconCalendar} alt='calendar' />
          </div>}
        {datePopup
          ? <div className='absolute top-57 md:top-[142px]'>
            <CustomDatePicker date={date} setDate={setDate} setDateView={setDateView} setDatePopup={setDatePopup} prodRef={prodRef} />
          </div>
          : null}
        {auth === 'COM' && <Btn inOut={inOut} setInOut={setInOut} />}
        <div className='w-[265px] sm:w-[318px] md:w-[750px] flex items-center justify-between mt-20 md:mt-[50px]'>
          <StatusBtn statusTab={statusTab} setStatusTab={setStatusTab}>전체</StatusBtn>
          <StatusBtn statusTab={statusTab} setStatusTab={setStatusTab}>조치대기</StatusBtn>
          <StatusBtn statusTab={statusTab} setStatusTab={setStatusTab}>승인대기</StatusBtn>
          <StatusBtn statusTab={statusTab} setStatusTab={setStatusTab}>조치완료</StatusBtn>
        </div>
      </div>
      <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-177px)] md:h-[calc(100%-442px)]'>
        <div className='w-[260px] sm:w-[308px] md:w-[750px] pt-10 mb-20 md:pt-[25px] md:mb-[50px]'>
          {nonconform.length == 0 ? <p className={`text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate`}>조회된 데이터가 없습니다.</p> : null}
          {statusTab === '전체' && nonconform?.map((nonconform: any) => {
            return (<div key={nonconform.sftyChkSeq}>{(auth === 'KOX' || auth === 'SRV')
              ? <DataRow detailHandler={detailHandler} nonconform={nonconform} />
              : <DataRowCOM detailHandler={detailHandler} nonconform={nonconform} />}</div>);
          })}
          {statusTab === '조치대기' && nonconform?.filter((data: any) => data.prcsStat === '001').map((nonconform: any) => {
            return (<div key={nonconform.sftyChkSeq}>{(auth === 'KOX' || auth === 'SRV')
              ? <DataRow detailHandler={detailHandler} nonconform={nonconform} />
              : <DataRowCOM detailHandler={detailHandler} nonconform={nonconform} />}</div>);
          })}
          {statusTab === '승인대기' && nonconform?.filter((data: any) => data.prcsStat === '002').map((nonconform: any) => {
            return (<div key={nonconform.sftyChkSeq}>{(auth === 'KOX' || auth === 'SRV')
              ? <DataRow detailHandler={detailHandler} nonconform={nonconform} />
              : <DataRowCOM detailHandler={detailHandler} nonconform={nonconform} />}</div>);
          })}
          {statusTab === '조치완료' && nonconform?.filter((data: any) => data.prcsStat === '003').map((nonconform: any) => {
            return (<div key={nonconform.sftyChkSeq}>{(auth === 'KOX' || auth === 'SRV')
              ? <DataRow detailHandler={detailHandler} nonconform={nonconform} />
              : <DataRowCOM detailHandler={detailHandler} nonconform={nonconform} />}</div>);
          })}
        </div>
      </div>
    </>
  );
}



const Btn = ({ inOut, setInOut }: any) => {
  return (
    <div className='flex'>
      <button onClick={() => setInOut('in')}
        className={inOut === 'in' ? `border rounded-l-[5px] md:rounded-l-[12px] border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
          : `border border-l-0 rounded-r-[5px] md:rounded-r-[12px] border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`}>받은 부적합</button>
      <button onClick={() => setInOut('out')}
        className={inOut === 'in' ? `border border-l-0 rounded-r-[5px] md:rounded-r-[12px] border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
          : `border rounded-l-[5px] md:rounded-r-[12px] border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`}>보낸 부적합</button>
    </div>
  );
};

const StatusBtn = ({ children, statusTab, setStatusTab }: any) => {
  return <button onClick={() => setStatusTab(children)}
    className={statusTab === children ? `w-63 sm:w-73 md:w-[182px] h-32 md:h-[80px] rounded-full bg-transparent border border-point text-point text-12 sm:text-14 md:text-35 font-preLight`
      : `w-63 sm:w-73 md:w-[182px] h-32 md:h-[80px] rounded-full bg-transparent border border-white text-12 sm:text-14 md:text-35 font-preLight`}>{children}</button>;
};

const DataRow = ({ detailHandler, nonconform }: any) => {
  return (
    <div onClick={() => detailHandler(nonconform)}>
      <div className='flex mt-22 md:mt-[55px] justify-between align-middle'>
        <p className='mx-10 md:mx-[25px] text-13 sm:text-15 md:text-37 font-preBold truncate mt-[3px]'>{nonconform.cmpnyNm}</p>
        {nonconform.prcsStat === '001' ?
          <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#585959] rounded-[4px] md:rounded-[10px] text-13 leading-15 md:text-32 md:leading-[37px] text-white flex items-center justify-center font-preLight'>조치대기</div>
          : nonconform.prcsStat === '003' ?
            <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#F2F4F6] rounded-[4px] md:rounded-[10px] text-13 leading-15 md:text-32 md:leading-[37px] text-[#9C9C9B] flex items-center justify-center font-preLight'>조치완료</div>
            : <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-point text-13 leading-15 md:text-32 md:leading-[37px]  rounded-[4px] md:rounded-[10px] text-white flex items-center justify-center font-preLight'>승인대기</div>}
      </div>
      {nonconform.exbtPlcNm ? <><p className='ml-10 text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px]'><span>{nonconform.exbtPlcNm} / {nonconform.bthNo}</span></p>
        <p className='ml-10 md:ml-[25px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px] text-[#706F6F] mt-8 md:mt-[20px] truncate'>{nonconform.cntnts}</p></>
        : null
      }
      <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-24' />
    </div>
  );
};

const DataRowCOM = ({ detailHandler, nonconform }: any) => {
  return (
    <div onClick={() => detailHandler(nonconform)}>
      <div className='flex mt-20 md:mt-[50px] justify-between align-middle'>
        <p className='mx-10 md:mx-[25px] text-13 sm:text-15 md:text-37 font-preBold truncate mt-[3px]'>{nonconform.cmpnyNm} / {nonconform.exbtPlcNm}</p>
        {nonconform.prcsStat === '001' ? <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#585959] rounded-[4px] md:rounded-[10px] text-13 leading-15 md:text-32 md:leading-[37px] text-white flex items-center justify-center font-preLight'>조치대기</div>
          : nonconform.prcsStat === '003' ? <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#F2F4F6] rounded-[4px] md:rounded-[10px] text-13 leading-15 md:text-32 md:leading-[37px]  text-[#9C9C9B] flex items-center justify-center font-preLight'>조치완료</div>
            : <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-point text-13 leading-15 md:text-32 md:leading-[37px] rounded-[4px] md:rounded-[10px] text-white flex items-center justify-center font-preLight'>승인대기</div>}
      </div>
      <p className='mx-10 md:mx-[25px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px] text-[#706F6F] truncate'>{nonconform.cntnts}</p>
      <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-24 md:mt-[60px]' />
    </div>
  );
};